import { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingOverlay = ({ isLoading, children }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShowOverlay(true);
    } else {
      setShowOverlay(false);
    }
  }, [isLoading]);

  return (
    <>
      {children}
      {showOverlay && (
        <div
          className="position-fixed top-0 start-0 end-0 bottom-0 bg-dark d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <Spinner animation="border" role="status" variant="light">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
};

export default LoadingOverlay;
